import { Box } from "@mui/material"
import type React from "react"
import { useGetFirstRelatedCriticalThreat } from "../CriticalThreats/useGetFirstRelatedCriticalThreat.js"
import { MainContent } from "../MainContent.js"
import { LocationDetailsTabs } from "./LocationDetailsTabs.js"

export const LocationDetails: React.FC<{
  location_id: string
  title: string
  subtitle?: string
}> = ({ location_id, title, subtitle }) => {
  const formattedTitle = title && subtitle ? `${title} ` : title
  const { relatedCriticalThreat } =
    useGetFirstRelatedCriticalThreat(location_id)

  return (
    <Box
      sx={{
        paddingTop: "14px",
      }}
    >
      <MainContent
        headerProps={{
          title: formattedTitle || "",
          subtitle: subtitle,
          showBackButton: true,
          relatedCriticalThreat,
        }}
      >
        <LocationDetailsTabs />
      </MainContent>
    </Box>
  )
}
